import styled from "styled-components";

export const Title = styled.h1`
  margin-top: 4rem;
  font-size: 2em;
  color: ${(props) => props.theme.textPrimary};
  text-align: center;
`;
